import { Pipe, PipeTransform } from '@angular/core';
import { Location } from '@angular/common';
import { PlatformInformationService } from '../services/platform-information.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Pipe({
  name: 'platformurl'
})
export class PlatformurlPipe implements PipeTransform {

  constructor(private platformservice: PlatformInformationService, private localizeRouterService: LocalizeRouterService) { }

  transform(relativeUrl: string, withLang: boolean = false): string {
    if (withLang) {
      if (this.platformservice.getCurrentPlatform(this.localizeRouterService.parser.currentLang) && relativeUrl) {
        return Location.joinWithSlash(
          this.platformservice.getCurrentPlatform(this.localizeRouterService.parser.currentLang),
          relativeUrl);
      }
    }
    if (this.platformservice.getCurrentPlatform() && relativeUrl) {
      return Location.joinWithSlash(this.platformservice.getCurrentPlatform(), encodeURI(relativeUrl));
    }
  }

}
